module.exports = require("date-fns/startOfDay");